import objectAssign from 'object-assign';
import initialState from './initialState';
import { DISPATCHER_REGISTER_SUCCESS, DISPATCHER_REGISTER_FAILED, DISPATCHER_REGISTER_REQUEST } from '../constants/actionTypes';

export default function dispatcherRegisterFormReducer(state = initialState.dispatcherRegisterPageState, action) {

  switch (action.type) {
    case DISPATCHER_REGISTER_SUCCESS:
      return objectAssign({}, state, { loaded: true, error: false, data: action.data, message: null });

    case DISPATCHER_REGISTER_FAILED:
      return objectAssign({}, state, { loaded: false, error: true, message: action.message });

    case DISPATCHER_REGISTER_REQUEST:
      return objectAssign({}, state, { loaded: false, error: null });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dispatcherRegisterFormReducer.js